import React, { useState, useEffect, useContext } from "react";
import Sidebar from "../../../Components/AdminComponents/Sidebar/Sidebar";
import Header from "../../../Components/AdminComponents/Header/Header";
import adminInstance from "../../../instance/AdminInstance";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../../../Contexts/UserContext";
import { AdminContext } from "../../../Contexts/AdminContext";

const DocumentList = () => {
  const [activeDoc, setActiveDoc] = useState("Cookies Notice");
  const [documentData, setDocumentData] = useState(null);
  const [loading, setLoading] = useState(false);

  const [editingIndex, setEditingIndex] = useState(null);
  const [editSubtitle, setEditSubtitle] = useState("");
  const [editSubData, setEditSubData] = useState([]);

  const { Admin } = useContext(AdminContext);

  const navigate = useNavigate();

  const documentNames = [
    "Cookies Notice",
    "Terms and Conditions",
    "Privacy Notice",
  ];

  const fetchDocument = async (name) => {
    setLoading(true);
    try {
      const response = await adminInstance.get("/api/super_admin/terms/get_term", {
        params: { name },
      });
      setDocumentData(response.data);
    } catch (error) {
      console.error("Failed to fetch document:", error);
      setDocumentData(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDocument(activeDoc);
  }, [activeDoc   ]);

  const handleEdit = (index) => {
    setEditingIndex(index);
    setEditSubtitle(documentData.policy[index].subtitle);
    setEditSubData(documentData.policy[index].subData || []);
  };

  const handleCancel = () => {
    setEditingIndex(null);
    setEditSubtitle("");
    setEditSubData([]);
  };

  const handleSave = async (index) => {
    try {
      const cleanedSubData = editSubData
        .map((item) => item.trim())
        .filter((item) => item !== "");

      const updatedPolicy = [...documentData.policy];
      updatedPolicy[index] = {
        subtitle: editSubtitle.trim(),
        subData: cleanedSubData,
      };

      const response = await adminInstance.put("/api/super_admin/terms/update_term", {
        id: documentData._id,
        policy: updatedPolicy,
      });

      fetchDocument(activeDoc)


      setEditingIndex(null);
    } catch (error) {
      console.error("Failed to update policy section:", error);
    }
  };

  const handleDelete = async (index) => {
    const confirmed = window.confirm("Are you sure you want to delete this section?");
    if (!confirmed) return;

    try {
      const updatedPolicy = [...documentData.policy];
      updatedPolicy.splice(index, 1);

      const response = await adminInstance.put("/api/super_admin/terms/update_term", {
        id: documentData._id,
        policy: updatedPolicy,
      });

      setDocumentData((prev) => ({
        ...prev,
        policy: updatedPolicy,
      }));

      setEditingIndex(null);
    } catch (error) {
      console.error("Failed to delete policy section:", error);
    }
  };

  const handleAddDocument = () => {
    navigate("/admin/document/form");
  };

  return (
    <div style={{ display: "flex" }}>
      <Sidebar />
      <div style={{ flex: 6, padding: "20px" }}>
        <Header />
        <div style={{ padding: "20px" }}>
          {/* Tabs and Add Button */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "20px",
          
            }}
          >
            <div style={{ display: "flex", gap: "12px" }}>
              {documentNames.map((doc) => (
                <button
                  key={doc}
                  onClick={() => setActiveDoc(doc)}
                  style={{
                    padding: "10px 20px",
                    borderRadius: "6px",
                    border: "none",
                    cursor: "pointer",
                    backgroundColor: activeDoc === doc ? "#2563eb" : "#e5e7eb",
                    color: activeDoc === doc ? "#ffffff" : "#111827",
                    fontWeight: "500",
                    
                  }}
                >
                  {doc}
                </button>
              ))}
            </div>
 {


                            Admin.role === "superadmin" &&
            <button
              onClick={handleAddDocument}
              style={{
                padding: "10px 16px",
                backgroundColor: "#10b981",
                color: "#fff",
                border: "none",
                borderRadius: "6px",
                fontWeight: "500",
                cursor: "pointer",
              }}
            >
              + Add Document
            </button>
}
          </div>

          {/* Document Content */}
          {loading ? (
            <p>Loading...</p>
          ) : documentData ? (
            <div
              style={{
                backgroundColor: "#f9fafb",
                padding: "20px",
                borderRadius: "8px",
             
              }}
            >
              {/* Description */}
              {documentData.description && (
                <p
                  style={{
                    fontSize: "14px",
                    color: "#6b7280",
                    marginBottom: "16px",
                      
                  }}
                >
                  {documentData.description}
                </p>
              )}

              {/* Policy Sections */}
              {Array.isArray(documentData.policy) &&
                documentData.policy.length > 0 ? (
                documentData.policy.map((section, index) => (
                  <div key={index} style={{ marginBottom: "24px" , }}>
                    {editingIndex === index ? (
                      <div
                        style={{
                          padding: "12px",
                          backgroundColor: "#f3f4f6",
                          borderRadius: "6px",
                        }}
                      >
                        <input
                          value={editSubtitle}
                          onChange={(e) => setEditSubtitle(e.target.value)}
                          placeholder="Subtitle"
                          style={{
                            width: "100%",
                            padding: "8px",
                            marginBottom: "10px",
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                          }}
                        />
                        <textarea
                          value={editSubData.join("\n")}
                          onChange={(e) =>
                            setEditSubData(e.target.value.split("\n"))
                          }
                          placeholder="SubData (one per line)"
                          rows={5}
                            style={{
    width: "100%",
    padding: "12px 16px",
    border: "1px solid #d1d5db", // light gray
    borderRadius: "8px",
    fontSize: "16px",
    fontFamily: "inherit",
    backgroundColor: "#f9fafb",
    color: "#111827",
    boxShadow: "inset 0 1px 2px rgba(0, 0, 0, 0.05)",
    transition: "border-color 0.2s, box-shadow 0.2s",
    outline: "none",
    resize: "vertical",
  }}
  onFocus={(e) => {
    e.target.style.borderColor = "#2563eb"; // blue border on focus
    e.target.style.boxShadow = "0 0 0 3px rgba(37, 99, 235, 0.2)";
  }}
  onBlur={(e) => {
    e.target.style.borderColor = "#d1d5db"; // revert on blur
    e.target.style.boxShadow = "inset 0 1px 2px rgba(0, 0, 0, 0.05)";
  }}
                        />
                        <div style={{ display: "flex", gap: "10px" }}>
                          <button
                            onClick={() => handleSave(index)}
                            style={{
                              backgroundColor: "#10b981",
                              color: "white",
                              border: "none",
                              borderRadius: "4px",
                              padding: "8px 16px",
                            }}
                          >
                            Save
                          </button>
                          <button
                            onClick={handleCancel}
                            style={{
                              backgroundColor: "#e5e7eb",
                              color: "#111827",
                              border: "none",
                              borderRadius: "4px",
                              padding: "8px 16px",
                            }}
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    ) : (
                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <h2
                            style={{
                              fontSize: "18px",
                              fontWeight: "600",
                              marginBottom: "8px",
                            }}
                          >
                            {section.subtitle}
                          </h2>
                          {


                            Admin.role === "superadmin" &&
                            <div style={{ display: "flex", gap: "10px" }}>
                              <button
                                onClick={() => handleEdit(index)}
                                style={{
                                  backgroundColor: "#3b82f6",
                                  color: "white",
                                  border: "none",
                                  borderRadius: "4px",
                                  padding: "4px 12px",
                                  fontSize: "14px",
                                  height: "30px",
                                }}
                              >
                                Edit
                              </button>
                              {/* <button
                              onClick={() => handleDelete(index)}
                              style={{
                                backgroundColor: "#ef4444",
                                color: "white",
                                border: "none",
                                borderRadius: "4px",
                                padding: "4px 12px",
                                fontSize: "14px",
                                height: "30px",
                              }}
                            >
                              Delete
                            </button> */}
                            </div>
                          }
                        </div>

                        {Array.isArray(section.subData) &&
                          section.subData.filter((s) => s.trim() !== "").length > 0 ? (
                          <ul
                            style={{
                              paddingLeft: "20px",
                              listStyleType: "disc",
                              lineHeight: "1.8",
                            }}
                          >
                            {section.subData
                              .filter((item) => item.trim() !== "")
                              .map((item, idx) => (
                                <li key={idx}>{item}</li>
                              ))}
                          </ul>
                        ) : (
                          <p style={{ color: "#6b7280", marginLeft: "12px" }}>
                            No sub points.
                          </p>
                        )}
                      </div>
                    )}
                  </div>
                ))
              ) : (
                <p style={{ color: "#6b7280" }}>No policy sections available.</p>
              )}
            </div>
          ) : (
            <p style={{ color: "red" }}>Document not found.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default DocumentList;
